export function readStringClaim(claims: unknown, key: string): string | null {
  if (typeof claims !== "object" || claims === null || !(key in claims)) {
    return null;
  }

  const value = (claims as Record<string, unknown>)[key];
  return typeof value === "string" && value.length > 0 ? value : null;
}
